import { jsx as m } from "react/jsx-runtime";
import { c as r } from "../../index-LULxUVKG.js";
import { s } from "../../Tabs.module-5GGKgLcA.js";
const i = ({
  children: a,
  className: e,
  hidden: o,
  ...t
}) => /* @__PURE__ */ m(
  "section",
  {
    className: r(
      s.tabPanel,
      { [s.hidden]: o },
      e
    ),
    role: "tabpanel",
    ...t,
    children: a
  }
);
export {
  i as TabPanel
};
